const mutations = {
  component(state, arg) {
    state.component = arg;
  },
};

export default mutations;
